import axios from 'axios'
import host from '@/utils/request/host.js'
import router from '@/router'
import md5 from 'js-md5'
import os from '@utils/os'
import store from '@/store/index'
import { Dialog } from 'vant'
import { showModal } from './util.js'

const CancelToken = axios.CancelToken

// const service = axios.create({
//   baseURL: '',
//   timeout: 60000
// })
const service = val => {
  const instance = axios.create({
    baseURL: '',
    timeout: 10000,
    ...val
  })

  instance.interceptors.request.use(
    config => {
      return config
    },
    error => {
      return Promise.reject(error)
    }
  )

  instance.interceptors.response.use(
    response => {
      const res = response.data
      const config = response.config
      const fQueryReginfo = config.url.includes('func=fQueryReginfo')
      if (res.code == 0 || fQueryReginfo) {
        return res
      } else {
        // store.dispatch('user/logout')
        // router.push('/login')
        showModal({
          showCancel: false,
          confirmText: '知道了',
          content: res.codeDesc
        }).then(rs => {
          console.log(res, rs, 'shshshs----')
          if (res && res.code && res.code === 401) {
            store.dispatch('user/logout')
            router.push('/login')
          }
        })
        return Promise.reject(res)
      }
      return res
    },
    error => {
      console.log(error) // for debug
      vant.Toast.fail(error.msg)
      return Promise.reject(error)
    }
  )
  return instance
}

const request = option => {
  let {
    baseUrl = 'address',
    url = '/hospro/hospital/selInfo',
    baseURL = '',
    timeout = 10000,
    data,
    params,
    headers,
    cancelToken
  } = option
  const token = localStorage.getItem('token')
  const userID = localStorage.getItem('userID')
  const hospitalID =
    store.state.user && store.state.user.userInfos && store.state.user.userInfos.hospitalID
  // 拼接url
  url = `${host.javaDoMain}${url}`

  // 设置headers
  if (!headers) {
    headers = {}
  }
  headers.Authorization = token ? `Bearer ${token}` : ''
  headers.hospitalID = hospitalID

  let paramsObj = {
    token,
    userID
  }
  if (data) {
    Object.assign(data, paramsObj, {
      hospitalID: data.hospitalID || hospitalID
    })
  }
  if (params) {
    Object.assign(params, paramsObj, {
      hospitalID: params.hospitalID || hospitalID
    })
  }

  // 取消请求
  if (!cancelToken) {
    const source = CancelToken.source()
    cancelToken = source.token
    option.source = source
  }
  const target = {
    ...option,
    url,
    headers
  }

  return service({
    baseURL,
    timeout
  })(target)
}

export default request
